import {feLogger} from './index';

enum RepType {
    Click = 'click',
    Show = 'show',
}

// PRD: https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/2tsPs8CtSd/PCsNaliPM8/T42_eNAzWWw1mj
const reportIds = {
    onlineTodoCheckboxClick: '60002.2.23',
    onlineTodoUpdate: '60002.2.24',
    todoCreate: '60002.4.4',
    onlineTodoConvertBtnClick: '60002.4.5',
    onlineTodoShow: '60002.4.6',
    autoTransOnlineTodo: '80001.2.137',
};

// 7: 点击勾选完成，11：点击取消勾选完成
export const reportOnlineTodoCheckboxClick = (complete: boolean) => {
    return feLogger({
        rep_id: reportIds.onlineTodoCheckboxClick,
        rep_type: RepType.Click,
        rep_params: {
            source: complete ? '7' : '11',
        },
    });
};

// 2: 修改标题，4：修改执行人，6：修改截止时间
export const reportOnlineTodoUpdate = (source: '2' | '4' | '6') => {
    return feLogger({
        rep_id: reportIds.onlineTodoUpdate,
        rep_type: RepType.Click,
        rep_params: {
            source,
        },
    });
};

// 普通待办新建
export const reportTodoCreate = () => {
    return feLogger({
        rep_id: reportIds.todoCreate,
        rep_type: RepType.Click,
    });
};

// 如流待办转换按钮点击
export const reportOnlineTodoConvertBtnClick = () => {
    return feLogger({
        rep_id: reportIds.onlineTodoConvertBtnClick,
        rep_type: RepType.Click,
    });
};

// 如流待办展现
export const reportOnlineTodoShow = (list: string[]) => {
    if (!list.length) {
        return;
    }
    return feLogger({
        rep_id: reportIds.onlineTodoShow,
        rep_type: RepType.Show,
        rep_params: {
            count: list.length,
        },
    });
};

// 自动转换如流待办
export const reportAutoTransOnlineTodo = (list: string[]) => {
    if (!list.length) {
        return;
    }
    return feLogger({
        rep_id: reportIds.autoTransOnlineTodo,
        rep_type: RepType.Click,
        rep_params: {
            count: list.length,
        },
    });
};
